/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ItemResponseType = {
    DoesntApply: 'doesnt_apply',
    CantFind: 'cant_find',
    SomeoneElseHasIt: 'someone_else_has_it',
} as const;
export type ItemResponseType = typeof ItemResponseType[keyof typeof ItemResponseType];


export function instanceOfItemResponseType(value: any): boolean {
    for (const key in ItemResponseType) {
        if (Object.prototype.hasOwnProperty.call(ItemResponseType, key)) {
            if (ItemResponseType[key as keyof typeof ItemResponseType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ItemResponseTypeFromJSON(json: any): ItemResponseType {
    return ItemResponseTypeFromJSONTyped(json, false);
}

export function ItemResponseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemResponseType {
    return json as ItemResponseType;
}

export function ItemResponseTypeToJSON(value?: ItemResponseType | null): any {
    return value as any;
}

export function ItemResponseTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ItemResponseType {
    return value as ItemResponseType;
}

